import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Rating from 'react-rating';
import 'font-awesome/css/font-awesome.min.css';
import Swal from 'sweetalert2';

const DonateDialogue = ({ onClose }) => {
  const [avgRating, setAvgRating] = useState(0.0)
  const [userRating, setUserRating] = useState(0)
  const [user_id, setUserId] = useState(0);
  
  const serverHost = process.env.REACT_APP_SERVER_HOST

  const handleSubmit = async (rating) => {
    if (user_id) {
      const formData = new FormData();
      
      formData.append('rating', rating)
      formData.append('user_id', user_id)

      try {
        const response = await fetch(`${serverHost}/rate`, {
          method: 'POST',
          body: formData,
        });      
        const result = await response.json();
  
        if (response.status === 200) {
          fetchRating();
        } else {
          Swal.fire({
            title: 'Failed to submit rating',
            text: result.error,
            icon: 'error',
            confirmButtonText: 'Close'
          });
        }
      } catch (error) {
        Swal.fire({
          title: 'Failed to submit rating',
          text: error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } else {
      Swal.fire({
        title: 'Failed to submit rating',
        text: 'Please sign in to rate our app',
        icon: 'error',
        confirmButtonText: 'Close'
      });
    }
  }

  const fetchRating = () => {
    let url;
  
    if (sessionStorage.getItem("user_id") !== null) {
      const user_id = parseInt(sessionStorage.getItem("user_id"), 10);
      url = `${serverHost}/rating?user_id=${user_id}`;
    } else {
      url = `${serverHost}/rating`;
    }
  
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        setAvgRating(data.avg_rating || 0.0);
  
        if (data.hasOwnProperty('user_rating')) {
          setUserRating(data.user_rating);
        }
      })
      .catch(error => console.error('Error fetching rating:', error));
  };  

  useEffect(() => {
    setUserId(parseInt(sessionStorage.getItem("user_id"), 10) || 0);
    fetchRating();
  }, []);
  
  return (
    <>
      <Overlay />
      <StyledDonateDialogue>
        <h3>Thank you 🙏<br />For your Support</h3>
        {/* <p>You can make UPI payments using the QR code given below</p>
        <QRCodeWrapper>
          <img src="images/gpay.png" alt="Donation" />
        </QRCodeWrapper> */}
        <p>We are proudly rated <b>{avgRating}</b> by our users 💪</p>
        <ImageContainer>
          <img src="images/support.png" alt="Support Icon" />
        </ImageContainer>
        {userRating?
          <p style={{"marginBottom":"10px"}}>Thank you for</p>:
          <p style={{"marginBottom":"10px"}}>Help us improve by</p>
        }
        <h4>Rating Us</h4>
        <Rating
          initialRating={userRating? userRating:0}
          style={{ marginTop: "20px" }}
          emptySymbol={<StarIcon className="fa fa-star-o fa-2x" />}
          fullSymbol={<StarIcon filled className="fa fa-star fa-2x" />}
          onClick={handleSubmit}
        />
        <CloseButton onClick={onClose} style={{"color": "black"}}><i className="fa fa-close" /></CloseButton>
      </StyledDonateDialogue>
    </>
  );
};

export default DonateDialogue;

const StyledDonateDialogue = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  border-radius: 10px;
  background: #fff;
  align-items: center;
  position: absolute;
  padding: 20px 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  p {
    font-size: 18px;
    
    b {
      color: gold;
      font-size: 24px;
    }
  }

  h3 {
    margin: 20px 0;
    font-size: 2em;
    color: #6559A2;
  }

  h4 {
    margin: 0 0;
    font-size: 2em;
    color: #6559A2;
  }

  @media only screen and (max-width: 600px) {
    width: 90%;
    background: #fff;
    padding: 20px 5px;

    h3 {
      font-size : 22px;
    }
  }
`;

const QRCodeWrapper = styled.div`
  .header {
    img {
      width: 100%;
    }
  }
`;

const StarIcon = styled.i`
  color: ${({ filled }) => (filled ? 'gold' : 'grey')};
  margin-left: 10px;
`;

const CloseButton = styled.button`
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const ImageContainer = styled.div`
  text-align: center;
  background: transparent;
  padding: 0 20px;
  
  img {
    background: transparent;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;
